<template>
  <div class="flex xs12 md12 offset--md1 lg12 sm12">
    <div class="markup-tables">

        <table label="Consents" class="va-table">
          <thead>
            <tr>
              <th class="md0">Consent Title</th>
              <th class="md0">Consent Question</th>
            </tr>
          </thead>

          <tbody name="slide" is="transition-group" appear mode="out-in">
              <tr v-for="(consent,index) in consents" :key="index">
                <td>{{consent.consentTitle}}</td>
                <td>{{consent.consentQuestion}}</td>
                <td>
                  <va-button
                    flat
                    small
                    color="danger"
                    @click.prevent="remove(consent)"
                    class="ma-0"
                  >{{ $t('tables.delete') }}</va-button>
                </td>
              </tr>
          </tbody>
        </table>

    </div>
  </div>
</template>

<script>
export default {
  props: ['consents'],
  data () {
    return {}
  },
  methods: {
    remove (consent) {
      this.$emit('consentRowDeleted', consent)
    },
  },
}
</script>

<style scoped>
.slide-enter {
  opacity: 0;
}
.slide-enter-active {
  animation: slide-in 1s ease-out forwards;
  transition: opacity 1s;
}
.slide-leave {
}
.slide-leave-active {
  animation: slide-out 1s ease-in forwards;
  opacity: 0;
  transition: opacity 1s;
  position:absolute;
}
.slide-move{
    transition: transform 1s;
}
@keyframes slide-in {
  from {
    transform: translateY(20px);
  }
  to {
    transform: translateY(0);
  }
}
@keyframes slide-out {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(20px);
  }
}

va-card{
  transition: 1s linear
}
</style>
